// ── Column reference formatting + text insertion ─────────────────────────
// The engine only accepts STATIC column reads (row.name or row["name"]), so
// these are the only two shapes the editor ever writes.

const IDENT = /^[A-Za-z_$][A-Za-z0-9_$]*$/;

export function isIdentifier(name) {
  return IDENT.test(String(name));
}

export function columnRef(name) {
  const s = String(name);
  return isIdentifier(s) ? `row.${s}` : `row[${JSON.stringify(s)}]`;
}

// Insert `insertion` at [selStart, selEnd) and put the caret after it.
export function insertAtCursor(text, selStart, selEnd, insertion) {
  const start = Math.max(0, Math.min(selStart, text.length));
  const end = Math.max(start, Math.min(selEnd, text.length));
  const next = text.slice(0, start) + insertion + text.slice(end);
  const caret = start + insertion.length;
  return { text: next, selStart: caret, selEnd: caret, hlStart: start, hlEnd: caret };
}

// A held value whose text carries formatting a plain number wouldn't:
// "$1,234", "50%", "(100)", "12abc" — at least one digit, and not just a plain
// number. A column of plain digit strings (a CSV) is not flagged: num() adds
// nothing there for the user to remember.
const PLAIN_NUMBER = /^[+-]?(?:\d+\.?\d*|\.\d+)(?:[eE][+-]?\d+)?$/;

export function hasNumberFormatting(v) {
  if (typeof v !== 'string') return false;
  const s = v.trim();
  return s !== '' && /\d/.test(s) && !PLAIN_NUMBER.test(s);
}

// Columns that are numeric by inference but whose held values carry
// formatting (so the user needs num()).
export function storedAsText(rows, name, sample = 100) {
  let seen = 0;
  for (const r of rows || []) {
    const v = r?.[name];
    if (v == null || String(v).trim() === '') continue;
    if (hasNumberFormatting(v)) return true;
    if (++seen >= sample) break;
  }
  return false;
}
